export class DistributionReason {
    code: string;
    subCode: string;
    description: string;
    isTaxExempt?: boolean;
}